import { IconWithHover } from '@/components/IconWithHover';
import CustomTooltip from '@/components/ToolTip/CustomTooltip';
import { useBulkDownloadFileMutation, useDownloadFileMutation } from '@/hooks/useDownloadFileMutation';
import DownloadMinimalistic from '@/images/DownloadMinimalistic.svg';
import { useAnalytics } from '@/services/analytics';
import { useSelectedVideos } from '@/state/video-library/videoLibrary';
import theme from '@/theme';
import { LibraryItemStatus } from '@d-id/types';
import styled from '@emotion/styled';
import { tooltipClasses } from '@mui/material/Tooltip';

const StyledToolTip = styled(CustomTooltip)`
    & .${tooltipClasses.tooltip} {
        background-color: ${theme.colors.secondary.main};
    }
`;

export const DownloadAction = () => {
    const { selected, reset } = useSelectedVideos();
    const mixpanel = useAnalytics();
    const { mutateAsync: bulkDownload } = useBulkDownloadFileMutation();
    const { mutateAsync: singleDownload } = useDownloadFileMutation();

    const selectedArray = [...selected.values()];

    const containsNotReady = selectedArray.find(v => ![LibraryItemStatus.Done, LibraryItemStatus.Ready].includes(v.status));
    if (containsNotReady) {
        return null;
    }

    const onDownload = async () => {
        if (!selected.size) {
            return;
        }

        mixpanel?.track('bulk-download-projects', {
            event: 'click',
            from: 'library',
            count: selected.size,
        });

        const downloadArray = selectedArray.map(video => ({
            dataurl: video.video_url!,
            filename: video.name ?? 'video',
            extension: '.mp4',
        }));

        if (downloadArray.length === 1) {
            await singleDownload(downloadArray[0]);
        }

        if (downloadArray.length > 1) {
            await bulkDownload(downloadArray);
        }

        reset();
    };

    return (
        <StyledToolTip title="Download videos">
            <IconWithHover src={DownloadMinimalistic} size="24px" onClick={onDownload} />
        </StyledToolTip>
    );
};
